/**
 * メニュー内の「プロジェクト一覧」「求人一覧」の表示・非表示を切り替える関数
 *
 * @param {boolean} contractRecruitingFlag - プロジェクト募集受付中かどうかのフラグ
 * @param {boolean} jobRecruitingFlag - 転職先募集受付中かどうかのフラグ
 *
 * 指定されたフラグに応じて、それぞれのリンクの表示・非表示を制御し、
 * また両方のリンクが非表示の場合は区切り線も非表示にする。
 */
export function updateMenuLinks(contractRecruitingFlag, jobRecruitingFlag) {
  const projectLink = document.getElementById("project-list-link");
  const jobLink = document.getElementById("job-list-link");
  const dividerLine = document.getElementById("divider-line");

  // プロジェクト一覧リンクの表示切替
  if (projectLink)
    projectLink.style.display = contractRecruitingFlag ? "" : "none";

  // 求人一覧リンクの表示切替
  if (jobLink) jobLink.style.display = jobRecruitingFlag ? "" : "none";

  // どちらのリンクも非表示か存在しない場合は区切り線も非表示
  const projectVisible = projectLink && projectLink.style.display !== "none";
  const jobVisible = jobLink && jobLink.style.display !== "none";

  if (dividerLine) {
    if (projectVisible || jobVisible) {
      dividerLine.style.display = "";
    } else {
      dividerLine.style.display = "none";
    }
  }
}
